module.exports = __webpack_public_path__ + "static/tw-mobile-view-fc454aa80f6b3e3cf56c451da356be17.jpg";